import { AxiosInstance } from "axios";

interface SubmissionEndpoints{ 
    [others: string]: any
}


interface SubmissionConfig{
    axios: AxiosInstance,
    endpoints: SubmissionEndpoints,
    [others: string]: any
}


export default function(config:SubmissionConfig){

    const initialState = {
        axios: config.axios,
        endpoints: config.endpoints
    }


    return function(state = initialState, action){

        switch(action.type){
            default: return state
        }

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/submission/submission-reducer.tsx